import { cn } from '@/lib/utils'
import { useContrastedBackground } from 'app/frontend/base/components/Card'
import { cva, type VariantProps } from 'class-variance-authority'

const itemLevelBadgeVariants = cva(
  'border rounded-lg flex gap-1 transition-opacity duration-300 items-center',
  {
    variants: {
      size: {
        sm: 'px-1.5',
        md: 'px-2',
        lg: 'px-3 py-1 gap-1.5',
      },
    },
    defaultVariants: {
      size: 'md',
    },
  },
)

const itemLevelTextVariants = cva('leading-tight', {
  variants: {
    size: {
      sm: 'text-[10px]',
      md: 'text-xs',
      lg: 'text-sm',
    },
  },
  defaultVariants: {
    size: 'md',
  },
})

const itemLevelLabelVariants = cva('text-muted-foreground font-semibold', {
  variants: {
    size: {
      sm: 'hidden',
      md: 'text-[10px]',
      lg: 'text-xs',
    },
  },
  defaultVariants: {
    size: 'md',
  },
})

type Props = VariantProps<typeof itemLevelBadgeVariants> & {
  details?: Pick<wowaudit.CharacterDetails, 'maxItemLevel'>
  className?: string
}

const ItemLevelBadge = ({ details, size, className }: Props) => {
  const background = useContrastedBackground()

  return (
    <div
      className={cn(
        background,
        itemLevelBadgeVariants({ size }),
        details?.maxItemLevel ? 'visible opacity-100' : 'invisible opacity-0',
        className,
      )}
    >
      <span className={itemLevelLabelVariants({ size })}>ilvl</span>

      <span className={itemLevelTextVariants({ size })}>
        {details?.maxItemLevel ?? '???'}
      </span>
    </div>
  )
}

export default ItemLevelBadge
